import React from 'react';
import { WaitingDots } from 'components/WaitingDots/WaitingDots';
import modal from 'decorators/Modal/Modal';

export const ModalLoadingUnwrapped = () => (
  <div className="modal__body">
    <div className="modal__column">
      <WaitingDots />
    </div>
  </div>
);

export const ModalLoading = modal()(ModalLoadingUnwrapped);
